import { Box } from '@mui/material';

import { Splitter, SplitterPanel } from 'primereact/splitter';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../app/store';
import { useUsuarioAdminSite, UsuarioEstaLogado } from '../utils/usuarioEstaLogado';
import { MenuLateral } from './MenuLateral';
import { useLocation } from 'react-router-dom'; // 👈 Importa o hook

import { MenuLateralProcessoSelecionado } from '../features/iniciarProcesso/MenuLateralProcessoSelecionado';
import { Header } from './header/Header';

import configSiteUrls from '../features/site/configs/configSiteUrls';
import configUrls from '../config/configUrls';
import { useIsEscolaLegislativo, useIsSaber, useIsSite, useIsSiteAdminArea } from '../utils/qualSistema';
import { SiteLayout } from '../features/site/componentes/layout/site/SiteLayout';
import { EscolaLegislativoLayout } from '../features/site/componentes/layout/escola/EscolaLegislativoLayout';
export function Layout({ children }: { children: React.ReactNode }) {
  //pegar o redux
  const dispatch = useDispatch();
  const headerButtons = useSelector((state: RootState) => state.header);

  let exibeMenuLateral = headerButtons.menuLateral;
  let exibeMenuProcessoSelecionado = headerButtons.menuProcessoSelecionado;
  const location = useLocation(); // 👈 Usa o hook
  let pegaURL = location.pathname; // 👈 Aqui você tem a URL atual

  const isSaber = useIsSaber(); // Aqui você pode chamar o hook diretamente
  const isSite = useIsSite(); // Aqui você pode chamar o hook diretamente
  const isEscola = useIsEscolaLegislativo(); // Aqui você pode chamar o hook diretamente

  const isSiteAdmin = useIsSiteAdminArea(); // Aqui você pode chamar o hook diretamente

  const isUsuarioAdminSite = useUsuarioAdminSite();

  useEffect(() => {
    if (isSiteAdmin && !isUsuarioAdminSite) {
      if (!UsuarioEstaLogado()) {
        alert('Acesso negado. Usuário não está logado.');
        window.location.href = configUrls.SITE_LOGIN;
      } else {
        alert('Acesso negado. Usuário não é administrador do site.');
        window.location.href = configUrls.SITE_HOME;
      }
    }
  }, [isSiteAdmin, isUsuarioAdminSite]);

  // 🔁 Se for rota "site", renderiza layout específico e encerra
  if (isSite) {
    return <SiteLayout>{children}</SiteLayout>;
  }

  if (isEscola) {
    return <EscolaLegislativoLayout>{children}</EscolaLegislativoLayout>;
  }

  if (!isSite && !isSaber && !isEscola) {
    //telas fora dos layouts saber e site
    //notFound e forbidden
    return <>{children} </>;
  }

  return (
    <Box
      sx={{
        m: 0,
        p: 0,
        color: 'black',
        backgroundColor: theme => theme.palette.grey[700],
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'column',
        width: { xs: '100%', sm: '100%', md: '100%', lg: '100%' },
        height: 'auto'
      }}
    >
      <>
        {pegaURL.includes('saber') && ( // 👈 Usa includes para verificar a URL
          <>
            <Header />

            {!UsuarioEstaLogado() && <div className="flex flex-col items-center p-1 w-full h-screen">{children}</div>}

            {!exibeMenuProcessoSelecionado ? (
              <>
                {UsuarioEstaLogado() && exibeMenuLateral && (
                  <div className="w-full flex  flex-row   gap-0  bg-slate-100 overflow-y-auto ">
                    <MenuLateral />

                    <Box display="flex" flexDirection="row" justifyContent="center" alignItems="flex-start" width="100%" height="100vh">
                      <Box width="90%">{children}</Box>
                    </Box>
                  </div>
                )}

                {UsuarioEstaLogado() && !exibeMenuLateral && (
                  <Box display="flex" flexDirection="row" justifyContent="center" alignItems="flex-start" width="100%" height="100vh" sx={{ backgroundColor: '#f0f0f0' }} overflow="auto">
                    <div className="flex flex-col items-center  bg-slate-100  w-full h-screen" style={{ width: '70%', backgroundColor: '#f0f0f0' }}>
                      {children}
                    </div>
                  </Box>
                )}
              </>
            ) : (
              <>
                <Box mt={0} p={0} sx={{ width: '100%' }}>
                  <Splitter style={{ height: '100vh' }} layout="horizontal" className="custom-splitter-bar">
                    <SplitterPanel className="flex align-items-center justify-content-center" size={20} minSize={20}>
                      <MenuLateralProcessoSelecionado />
                    </SplitterPanel>

                    <SplitterPanel className="flex align-items-center justify-content-center" size={80} minSize={50}>
                      <Box sx={{ width: '100%' }}>{children}</Box>
                    </SplitterPanel>
                  </Splitter>
                </Box>
              </>
            )}
          </>
        )}
      </>
    </Box>
  );
}
